// 📁 components/Settings/ProductsPage.jsx
//
// The Products tab in Settings. Thin wrapper over ModuleGridPage with the
// products config.

import React from 'react';
import { MIN_ACTIVE_PRODUCTS, PRODUCTS } from 'config/productsConfig';
import ModuleGridPage from '../ModuleGridPage';

const ProductsPage = () => (
	<ModuleGridPage
		title='Products'
		description='Manage access, lockers, and guest rooms from one place. Activate the products your organisation uses.'
		modules={PRODUCTS}
		minActive={MIN_ACTIVE_PRODUCTS}
		emptyText='No Zezamii products active. Your workspace needs at least one product to function.'
	/>
);

export default ProductsPage;
